// extracted by mini-css-extract-plugin
export default {"counrtyWrap":"CountryCard_counrtyWrap__ZQv38","counrtyAvatar":"CountryCard_counrtyAvatar__TXKvM","countryName":"CountryCard_countryName__BoFfP"};